import { createContext } from "react";
import type { DeviceType } from "../utils/consts";

export const DeviceContext = createContext<DeviceType | undefined>(undefined);
